import React from "react";

import Header from "../Global/Header";
import Banner from "../Menhomeone/Banner";
import Usp from "../Menhomeone/Usp";
import Program from "../Menhomeone/Program";
import LookInside from "../Menhomeone/LookInside";
import Pricing from "../Menhomeone/Pricing";
import AppDownload from "../Menhomeone/AppDownload";
import Call from "../Menhomeone/Call";
import Footer from "../Global/Footer";
import Gototop from "../Global/Gototop";

const Main = () => {
  return (
    <>
      <Header />
      <Banner />
      <div className="page_wrapper">
        <Usp />
        <Program />
        <LookInside />
        <Pricing />
        <AppDownload />
        <Call />
        <Footer />
        <Gototop />
      </div>
    </>
  );
};

export default Main;
